import { cn } from "@/lib/utils";

const MAP = {
  available: { label: "AVAILABLE", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  sold: { label: "SOLD", cls: "bg-red-100 text-red-700 border-red-300" },
  not_active: { label: "HIDDEN", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

export function StatusBadge({ status, className, big }) {
  const s = MAP[status] || MAP.available;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-md border font-bold uppercase tracking-wider",
        big ? "px-4 py-1.5 text-sm" : "px-2.5 py-1 text-[11px]",
        s.cls,
        className
      )}
    >
      {s.label}
    </span>
  );
}
